<header id="app-header">
  <span
    id="home"
    class="logo"
    [ngClass]="logoClass"
    (click)="onHomeClick()"></span>

  <nav id="app-nav">
    <p-tabMenu
      [model]="applicationsMenu"
      scrollable="true"
      (activeItemChange)="clearActiveSettings()"
      (click)="onClickTabMenuItem()"
      >
    </p-tabMenu>
  </nav>
  <nav id="app-settings">
    <p-tabMenu [model]="settingsMenu" [(activeItem)]="settingsActiveItem">
      <ng-template pTemplate="item" let-item>
        <a
          (click)="onClickTabMenuItem()"
          [ngClass]="{
              'settings-container': item.hasNotificationIcon, 
            }"
          [routerLink]="item.routerLink"
          routerLinkActive="p-highlight"
          role="presentation"
          [attr.tabindex]="item.disabled ? null : '0'"
          [attr.title]="item.title"
          [attr.id]="item.id">
          <div
            [ngClass]="{
                'settings-icon': item.hasNotificationIcon, 
              }"
            class="settings-menu-inner-item"
            [pTooltip]="item.tooltip | translate"
            [tooltipOptions]="tooltipOptions">
            <aur-icon class="menu-icon" iconStyle="outline">
              {{ item.icon }}
            </aur-icon>
          </div>
          <div class="notification-icon" *ngIf="item.hasNotificationIcon && notifications > 0">
            <main>
              <div class="badge-notification-bubble">
                <div
                  class="badge-notification-count">
                  {{ notifications }}
                </div>
              </div>
            </main>
          </div>
        </a>
      </ng-template>
    </p-tabMenu>

    <p-overlayPanel
      #settingsOp
      styleClass="nopadding"
      (onHide)="onSettingsOverlayHide()">
      <ng-template pTemplate="content">
        <div class="settings-dropdown">
          <div class="settings-header">
            <h5 class="title">
              {{ 'ARC_COMPOSITE_MENU_SETTINGS' | translate }}
            </h5>
          </div>
          <aur-menu [items]="settingsMenuItems" size="sm"></aur-menu>
        </div>
      </ng-template>
    </p-overlayPanel>

    <button
      aur-button
      (click)="op.toggle($event)"
      [pTooltip]="tooltipContent"
      tooltipStyleClass="profile-button-tooltip"
      [tooltipOptions]="tooltipOptions"
      id="profile-dropdown"
      class="profile-button"
      [ngClass]="{
        'p-highlight': currentRoute === 'profile' || isProfileOverlayVisible
      }">
      <div id="user-dropdown" class="nav-dropdown">
        <div id="user" class="flip">
          <a class="nav-item user-menu flip">
            <aur-icon iconStyle="outline">person</aur-icon>
            <span class="user-info">
              <span id="profile-user-name" class="user-name">{{
                userName
              }}</span>
              <span id="profile-tenant-name" class="tenant">{{
                tenantName
              }}</span>
            </span>
          </a>
        </div>
      </div>
    </button>
    <ng-template #tooltipContent>
      <span class="aur-tooltip-label">{{
        'ARC_COMPOSITE_LOGGEDINAS' | translate
      }}</span
      ><span class="aur-tooltip-legend">{{ userName }}</span
      ><span class="aur-tooltip-legend">{{ tenantName }}</span>
    </ng-template>
    <p-overlayPanel
      #op
      styleClass="nopadding"
      (onShow)="onProfileOverlayToggle(true)"
      (onHide)="onProfileOverlayToggle(false)">
      <ng-template pTemplate="content">
        <div class="profile-dropdown">
          <div class="profile-header">
            <h5 id="overlay-user-name" class="user-name">{{ userName }}</h5>
            <span id="overlay-tenant-name" class="tenant-name">{{
              tenantName
            }}</span>
          </div>
          <aur-menu [items]="loggedInMenu" size="sm"></aur-menu>
        </div>
      </ng-template>
    </p-overlayPanel>
  </nav>
</header>
